import {Authorization} from "@app/core/shared/domain/authorization";

export enum HttpMethod {
    get,
    post,
    put,
    patch,
    delete
}

type AuthorizationInput = Authorization | Promise<Authorization | null> | null;

export class HandlerParameters {

    readonly method: HttpMethod;
    readonly url: string;
    readonly header: Map<string, any>;
    readonly authorization: AuthorizationInput;
    readonly body: {};
    readonly params: Map<string, any>;

    constructor(builder: HandlerBuilder) {
        this.method = builder._method;
        this.url = builder._url;
        this.header = builder._header;
        this.authorization = builder._authorization;
        this.body = builder._body;
        this.params = builder._params;
    }
}

export class HandlerBuilder {

    _method: HttpMethod = HttpMethod.get;
    _url = "";
    _header = new Map();
    _authorization: Authorization | Promise<Authorization | null> | null = null;
    _body = {};
    _params = new Map();

    build(): HandlerParameters {
        return new HandlerParameters(this);
    }

    method(value: HttpMethod): HandlerBuilder {
        this._method = value;
        return this;
    }

    url(value: string): HandlerBuilder {
        this._url = value;
        return this;
    }

    header(value: Map<string, any>): HandlerBuilder {
        this._header = value;
        return this;
    }

    body(value: {}): HandlerBuilder {
        this._body = value;
        return this;
    }

    authorization(value: Authorization | Promise<Authorization | null> | null): HandlerBuilder {
        this._authorization = value;
        return this;
    }

    params(value: Map<string, any>): HandlerBuilder {
        this._params = value;
        return this;
    }
}
